<script setup>
import { ref } from 'vue';

// API-Basis-URL (für Produktion anpassen)
const API_URL = '/api';

const username = ref('');
const password = ref('');
const error = ref('');
const isLoading = ref(false);
const emit = defineEmits(['login-success']);

const handleSubmit = async (e) => {
  e.preventDefault();
  error.value = '';
  isLoading.value = true;

  try {
    console.log('Sende Login-Anfrage...');
    const response = await fetch('/api/auth.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        username: username.value,
        password: password.value
      })
    });

    const data = await response.json();
    console.log('Login-Antwort:', data);
    console.log('Password change required:', data.password_change_required);

    if (data.success && data.token) {
      console.log('Login erfolgreich, speichere Token');
      localStorage.setItem('adminToken', data.token);
      
      // Auth-Daten für Passwort-Änderung speichern
      const authData = {
        token: data.token,
        username: data.username,
        password_change_required: data.password_change_required,
        expires: data.expires
      };
      localStorage.setItem('admin_auth', JSON.stringify(authData));
      
      emit('login-success', authData);
    } else {
      console.log('Login fehlgeschlagen:', data.error);
      error.value = data.error || 'Anmeldung fehlgeschlagen';
    }
  } catch (err) {
    console.error('Login-Fehler:', err);
    error.value = 'Ein Fehler ist aufgetreten';
  } finally {
    isLoading.value = false;
  }
};
</script>

<template>
  <div class="admin-login">
    <div class="login-container">
      <h1>Admin-Login</h1>
      
      <form @submit="handleSubmit" class="login-form">
        <div class="form-group">
          <label for="username">Benutzername</label>
          <input
            type="text"
            id="username"
            v-model="username"
            required
            autocomplete="username"
          >
        </div>
        
        <div class="form-group">
          <label for="password">Passwort</label>
          <input
            type="password"
            id="password"
            v-model="password"
            required
            autocomplete="current-password"
          >
        </div>
        
        <div v-if="error" class="error-message">
          {{ error }}
        </div>
        
        <button type="submit" class="btn-login" :disabled="isLoading">
          {{ isLoading ? 'Wird angemeldet...' : 'Anmelden' }}
        </button>
      </form>
    </div>
  </div>
</template>

<style scoped>
.admin-login {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-color);
  padding: 2rem;
}

.login-container {
  width: 100%;
  max-width: 400px;
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

h1 {
  text-align: center;
  color: var(--primary-color);
  margin-bottom: 2rem;
  font-size: 1.8rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

label {
  font-size: 0.9rem;
  color: var(--text-muted);
}

input {
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s ease;
}

input:focus {
  outline: none;
  border-color: var(--primary-color);
}

.error-message {
  color: #dc3545;
  font-size: 0.9rem;
  text-align: center;
  padding: 0.5rem;
  background-color: rgba(220, 53, 69, 0.1);
  border-radius: 4px;
}

.btn-login {
  background-color: var(--primary-color);
  color: white;
  border: none;
  padding: 0.75rem;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.btn-login:hover:not(:disabled) {
  background-color: var(--primary-color-dark);
}

.btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

@media (max-width: 480px) {
  .login-container {
    padding: 1.5rem;
  }
  
  h1 {
    font-size: 1.5rem;
  }
}
</style> 